import { useTranslation } from "react-i18next"

import {
  MarketStatus,
  useLatestQuote,
  useMarketStatus,
} from "@/App/Equities/shared/services/marketData"
import {
  formatCurrency,
  useChangePaletteColor,
} from "@/App/Equities/shared/utils"
import { Typography } from "@/generated/material"

export type QuoteDataPointField = "askPrice" | "bidPrice"

interface QuoteDataPointProps {
  symbol: string
  field: QuoteDataPointField
}

export const QuoteDataPoint = ({ symbol, field }: QuoteDataPointProps) => {
  const { [field]: price } = useLatestQuote(symbol)
  const marketStatus = useMarketStatus()

  const color = useChangePaletteColor({
    current: price,
    fallback: "text-primary",
  })

  const { t } = useTranslation()

  return marketStatus === MarketStatus.Open ? (
    <Typography component="span" variant="inherit" color={color}>
      {formatCurrency(price)}
    </Typography>
  ) : (
    <>{t("marketClosed")}</>
  )
}
